module.exports = __webpack_public_path__ + "static/media/Korea_Brazil.8186b3ca.jpeg";